// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-body {
  background-color: #EDF2F5;
}

#candidateList {
  height: 300px;
  background-color: white;
  overflow-y: scroll;
  border-top: 1px solid #BBB;
  border-bottom: 1px solid #BBB;
}

.text-danger {
  color: indianred;
}

.closeSearch {
  cursor: pointer;
}

.closeSearch img.closeIdle {
  display: block;
}

.closeSearch img.closeHover {
  display: none;
}

.closeSearch:hover img.closeIdle {
  display: none;
}

.closeSearch:hover img.closeHover {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/analysis/jobSatisfactions/components/web/job-satisfactions-modal/job-satisfactions-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,0BAAA;EACA,6BAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EAA4B,cAAA;AAE5B;;AADA;EAA4B,aAAA;AAK5B;;AAHA;EAAkC,aAAA;AAOlC;;AANA;EAAmC,cAAA;AAUnC","sourcesContent":[".modal-body {\n    background-color: #EDF2F5;\n}\n\n#candidateList {\n    height: 300px;\n    background-color: white;\n    overflow-y: scroll;\n    border-top: 1px solid #BBB;\n    border-bottom: 1px solid #BBB;\n}\n\n.text-danger {\n    color: indianred;\n}\n\n.closeSearch {\n    cursor: pointer;\n}\n\n.closeSearch img.closeIdle {display:block}\n.closeSearch img.closeHover{display:none}\n\n.closeSearch:hover img.closeIdle {display:none}\n.closeSearch:hover img.closeHover {display:block}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
